import { render, staticRenderFns } from "./Demands.vue?vue&type=template&id=06bc5b73&scoped=true&"
import script from "./Demands.vue?vue&type=script&lang=js&"
export * from "./Demands.vue?vue&type=script&lang=js&"
import style0 from "./Demands.vue?vue&type=style&index=0&id=06bc5b73&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bc5b73",
  null
  
)

export default component.exports